<script setup>
import { RouterView, useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '@/mini/stores/auth'
import pinia from '@/stores/pinia'
import { useModalsStore } from '@/stores/modals'
import { useCardActionsStore } from '@/stores/cardActions'
import Header from './mini/components/Header.vue'
import HeaderBrand from './mini/components/HeaderBrand.vue'
import HeaderMenu from './mini/components/HeaderMenu.vue'
import Container from './mini/components/Container.vue'
import Boxes from './mini/components/Boxes.vue';
import Box from './mini/components/Box.vue';
import Sheet from './mini/components/Sheet.vue';
import Aside from './mini/components/Aside.vue';
import Main from './mini/components/Main.vue';
import Menu from './mini/components/Menu.vue';
import Credits from './mini/components/Credits.vue';
import Loader from './mini/components/Loader.vue';
import Top from './mini/components/Top.vue';
import MessageBox from '@/mini/components/MessageBox.vue'
import Footer from './mini/components/Footer.vue';
import FooterCopy from './mini/components/FooterCopy.vue';
import FooterLogo from './mini/components/FooterLogo.vue';
import Actions from './mini/components/Actions.vue'
import CardCreateModal from '@/components/CardCreateModal.vue'
import { IconoirProvider, PlusCircle, Dollar, CloudCheck, Refresh, PercentageCircle } from '@iconoir/vue'
import { useMenuState } from '@/mini/composables/useMenuState'

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore(pinia)
const modalsStore = useModalsStore(pinia)
const cardActionsStore = useCardActionsStore(pinia)
const { menuClose } = useMenuState()

function logout() {
  authStore.logout()
  router.replace({ name: 'login' })
}

</script>

<template>
  <IconoirProvider>
  <Loader />
  <Top />
  <MessageBox />

  <Sheet class="black-bg">
    <Header class="scroll-wh">
      <Container>
        <Boxes class="justify-content-between align-items-center">
          <HeaderBrand logo="/OPTCG_JJ_logo.svg" title="OPTCG <span class='h5'><span class='light'>by</span> J&J</span>"/>
          <HeaderMenu/>
        </Boxes>
      </Container>
    </Header>
    <Aside v-if="false" side="left">
    </Aside>
    <Main>
      <RouterView/>
    </Main>
    <Aside side="right">
      <Menu id="main-menu"
        :menuCloseOnClick=true
        :menuItems="[
          {
            title:'My cards', 
            routeName:'home'
          },
          {
            title:'Cards to buy', 
            routeName:'buy'
          },
          {
            title:'Cards to sell', 
            routeName:'sell'
          },
        ]"
        />
      <h4 class="light px-15 color-text S m-0">User</h4>
      <Menu id="user-menu"
        :menuCloseOnClick=true
      >
        <li v-if="authStore.isAuthenticated" class="item">
          <a href="#" class="danger-text" @click.prevent="logout">Logout</a>
        </li>
        <li v-else class="item">
          <RouterLink to="/login" class="success-text" @click="menuClose()">Login</RouterLink>
        </li>
      </Menu>
    </Aside>
  </Sheet>
  
  <Actions v-if="authStore.isAuthenticated" :groups="[
    {
      key: 'new-card',
      icon: PlusCircle,
      label: 'Add a new card',
      id: 'new-card',
      classes: 'blue-bg dark-blue-bg-hover',
      iconClass: 'blue-bg',
      onClick: modalsStore.openCreateCard,
    },
    ...(route.name === 'home' ? [{
      key: 'fetch-cards-value',
      icon: Dollar,
      label: 'Fetch prices',
      id: 'fetch-cards-value',
      classes: 'bad-bg dark-blue-bg-hover',
      iconClass: 'bad-bg',
      onClick: cardActionsStore.fetchFilteredPrices,
    },
    {
      key: 'cardtrader',
      icon: CloudCheck,
      label: 'CardTrader',
      id: 'cardtrader',
      classes: 'blue-bg dark-blue-bg-hover',
      iconClass: 'blue-bg',
      items: [
        {
          icon: CloudCheck,
          label: 'Check CT prices',
          onClick: cardActionsStore.checkCtPrices,
          iconClass: 'blue-bg',
        },
        {
          icon: Refresh,
          label: 'Fetch blueprints',
          onClick: cardActionsStore.fetchFilteredBlueprints,
          iconClass: 'blue-bg',
        },
      ],
    }] : []),
    ...(route.name === 'sell' ? [{
      key: 'cardtrader-sell',
      icon: CloudCheck,
      label: 'CardTrader',
      id: 'cardtrader-sell',
      classes: 'blue-bg dark-blue-bg-hover',
      iconClass: 'blue-bg',
      items: [
        {
          icon: CloudCheck,
          label: 'Update all listings',
          onClick: cardActionsStore.updateAllListings,
          iconClass: 'blue-bg',
        },
        ...[0.5, 0.75, 1, 1.25, 1.5, 2, 3].map(mult => ({
          icon: PercentageCircle,
          label: `Set bulk price: ${mult}x`,
          onClick: () => cardActionsStore.applyBulkMultiplier(mult),
          iconClass: 'blue-bg',
        })),
      ],
    }] : []),
  ]" />
  <Footer v-if="false">
    <Container>
        <Boxes spaceTopBot>
            <Box :size="33">
              <FooterCopy/>
            </Box>
            <Box :size="33">
              <FooterLogo logo="OPTCG_JJ_logo.svg"/>
            </Box>
            <Box :size="33">
              <Menu 
                id="footer-menu" 
                :menuItems="[
                  {
                    title:'home', 
                    routeName:'home', 
                    target:null
                  },
                  ]"
                  />
            </Box>
        </Boxes>
    </Container>
  </Footer>
  <Credits/>

  <CardCreateModal
    :visible="modalsStore.showCreateCard"
    @close="modalsStore.closeCreateCard"
    @saved="() => { modalsStore.closeCreateCard(); cardActionsStore.reloadCards() }"
  />

  </IconoirProvider>
</template>

<style>
:root {
  --logo-height: 4rem;
  --scroll-logo-height: 2rem;
}
</style>
